module.exports = __webpack_public_path__ + "static/media/14x18no2.b0013835.jpg";